import React from "react";
import { Box, CircularProgress } from "@material-ui/core";
import { useSchemaConfiguration } from "hooks/api";
import { useProcessingStatus } from "hooks";
import { SchemaForm, SchemaProvider } from "components/SchemaProvider";
import { useTranslation } from "react-i18next";

interface DetailsProps {
    materialSpecId: number;
    materialId: number;
}

export const Details = ({ materialSpecId, materialId }: DetailsProps) => {
    const { i18n } = useTranslation();
    const { isFetching, isError, data: configuration, refetch } = useSchemaConfiguration({
        key: "detailstab.json",
        matspec: materialSpecId,
        admaterial: materialId,
        language: i18n.language,
    });
    useProcessingStatus(false, isError);

    if (isFetching || !configuration) {
        return (
            <Box p={4} display="flex" justifyContent="center">
                <CircularProgress color="primary" size={40} />
            </Box>
        );
    }

    const { form, stepper } = configuration;

    return (
        <Box>
            <SchemaProvider schema={form} refetch={refetch}>
                <SchemaForm stepper={stepper} />
            </SchemaProvider>
        </Box>
    );
};
